<template>
    <kb-container fluid class="no-padding bottom-padding">
        <div class='top-padding'>
            <div class='inline-auto-width bottom-padding'><kb-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&larr;</kb-button></div>
            <div class='inline-auto-width small-left-margin bottom-padding small-right-margin'><kb-form-select @change='loadSelectedPage' v-model='currentPageNumber' :options="pageNumberSelectOptions" v-if="totalPages > 1"/></div>
            <div class='inline-auto-width bottom-padding'><kb-button variant='default' v-if="totalPages > 1" @click="loadNextPage">&rarr;</kb-button></div>
            <div class='inline-auto-width bottom-padding'>&nbsp;{{totalResults}}&nbsp;drafts found, click drawdown to view</div>
            <div class='inline-auto-width bottom-padding'><kb-form-checkbox class='inline-auto-width big-left-margin' v-model="detailsVisible" value="showing" unchecked-value="hidden">Show Details</kb-form-checkbox></div>
        </div>

        <kb-form-select v-model='thumbnailSize' :options='thumbnailSizeOptions' @change='setThumbnailsSize' class="inline-auto-width" />
        <share-button v-if='showShareButton'/>

        <div>
            <div :class='getImageContainerClass()' :key='pattern.PatternID' v-for="pattern in patterns">
                <router-link :to="{ name: 'DraftDetail', params: { id: pattern.PatternID, title: buildDraftDetailDisplayTitle(pattern) }}" :title="pattern.Tooltip">
                    <figure v-if='detailsVisible==="showing"'>
                        <img class='draft-image-thumbnail' :src="draftThumbnailImageUrl(pattern)" :alt="'Drawdown Image: ' + pattern.Tooltip" />
                        <figcaption v-if='detailsVisible==="showing"'>{{pattern.DisplayTitle}}</figcaption>
                    </figure>
                    <img v-if='!(detailsVisible==="showing")' class='draft-image-thumbnail' :src="draftThumbnailImageUrl(pattern)" :alt="'Drawdown Image: ' + pattern.Tooltip" />
                </router-link>
                <br/>
                <br v-if='showBoardLinks'/>
                <a href='#' v-if='showBoardLinks' @click="onRemoveFromBoard(pattern.PatternID)" class="small small-horizontal-padding">Remove</a>
            </div>
        </div>

        <div v-if='totalResults > 3' class="vertical-padding">
            <div class='inline-auto-width bottom-padding'><kb-button variant='default' v-if="totalPages > 1" @click="loadPreviousPage">&larr;</kb-button></div>
            <div class='inline-auto-width small-left-margin bottom-padding small-right-margin'><kb-form-select @change='loadSelectedPage' v-model='currentPageNumber' :options="pageNumberSelectOptions" v-if="totalPages > 1"/></div>
            <div class='inline-auto-width bottom-padding'><kb-button variant='default' v-if="totalPages > 1" @click="loadNextPage">&rarr;</kb-button></div>
            <div class='inline-auto-width bottom-padding'>&nbsp;{{totalResults}}&nbsp;drafts found, click drawdown to view</div>
            <div class='inline-auto-width bottom-padding'><kb-form-checkbox class='inline-auto-width big-left-margin' v-model="detailsVisible" value="showing" unchecked-value="hidden">Show Details</kb-form-checkbox></div>
        </div>
    </kb-container>
</template>

<script>

import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import dataService from '../mixins/dataService.js'
import shareButton from './ShareButton.vue'

export default {
    props: {
        itemsPerPage: {
            type: Number,
            required: true
        },
        initialPageNumber: {
            type: Number,
            required: true
        },
        patterns: {
            type: Array,
            default: () => { return [] }
        },
        totalResults: {
            type: Number,
            default: 0
        },
        showBoardLinks: {
            type: Boolean,
            required: false
        },
        showShareButton: {
            type: Boolean,
            required: false
        }
    },
    mixins: [urlsService, mediaService, dataService],
    components: {
        shareButton: shareButton
    },
    data() {
        return {
            pageNumberSelectOptions: [],
            thumbnailSize: this.getThumbnailDisplaySize(),
            thumbnailSizeOptions: [
                { text: 'Small Thumbnails', value: 1 },
                { text: 'Medium Thumbnails', value: 2 },
                { text: 'Large Thumbnails', value: 3 },
                { text: 'Largest Thumbnails', value: 4 }
            ],
            currentPageNumber: 0,
            detailsVisible: 'hidden'
        }
    },
    emits: ['thumbnailSizeChanged', 'pageNumberChanged', 'removeFromBoard'],
    methods: {
        onGoToPage(pageNum) {
            this.$emit('pageNumberChanged', { pageNumber: pageNum })
        },
        onRemoveFromBoard(patternId) {
            this.$emit('removeFromBoard', { patternId: patternId })
        },
        loadPageSelectOptions() {
            this.pageNumberSelectOptions = []
            let currentTotalPages = this.totalPages

            for (let c = 0; c < currentTotalPages; c++) {
                let prompt = 'Pg ' + (c + 1) + ' of ' + currentTotalPages
                this.pageNumberSelectOptions.push({ value: c, text: prompt })
            }
        },
        loadPreviousPage() {
            // console.log('in DraftSearchResults loadPreviousPage')
            if (this.currentPageNumber > 0) {
                this.currentPageNumber--
                this.onGoToPage(this.currentPageNumber)
            }
        },
        loadNextPage() {
            // console.log('in DraftSearchResults loadNextPage')
            if (this.currentPageNumber < this.totalPages-1) {
                this.currentPageNumber++
                this.onGoToPage(this.currentPageNumber)
            }
        },
        loadSelectedPage(pageValue) {
            // console.log('in DraftSearchResults loadSelectedPage, pageValue: ' + JSON.stringify(pageValue))
            this.onGoToPage(pageValue)
        },
        draftThumbnailImageUrl: function(draft) {
            let thumbOutputSize = this.calculateDraftThumbnailDisplaySize(draft, this.thumbnailSize)
            return this.draftImageUrlFunction(draft.PatternID, thumbOutputSize, this.currentOrientation, false, false, false, false, false, false, false, false, false, false, draft.ImagesExist)
        },
        draftDetailPageUrl: function(draft) {
            return this.buildDraftDetailUrl(draft)
        },
        setThumbnailsSize(newThumbnailSize) {
            if (this.isAuthenticated()) {
                // console.log('New thumbnailSize: ' + newThumbnailSize)
                this.thumbnailsSize = parseInt(newThumbnailSize) // needed because change events pass the value that the item is about to be changed to as a parameter, changing it later on the next tick instead
                let userSettings = this.$store.state.authUserSettings
                userSettings.ThumbnailSize = newThumbnailSize
                this.$store.commit('setFilters', userSettings)
                this.putUserSettings(this.authUser.UserID, userSettings, this.authUser.LoginToken)
                // console.log('about to emit thumbnailSizeChanged, size: ' + newThumbnailSize)
                this.$emit('thumbnailSizeChanged', { 'size': newThumbnailSize }) // lets the parent know so other draft components like the drawdown can be redrawn
            }
        },
        getThumbnailDisplaySize: function() {
            if (this.isAuthenticated()) {
                // console.log('in thumbnailDisplaySize authenticated, returning: ' + this.$store.state.authUserSettings.ThumbnailSize)
                return this.$store.state.authUserSettings.ThumbnailSize
            }
            // console.log('in thumbnailDisplaySize nonauthenticated, returning: 1')
            return 1
        },
        isAuthenticated: function() {
            let val = this.$store.getters.isAuthenticated
            // console.log('in isAuthenticated, returning ' + JSON.stringify(val))
            return val
        },
        getImageContainerClass: function() {
            if (this.detailsVisible==='showing') {
                return 'inline-auto-width captionsShowing'
            }
            else {
                return 'inline-auto-width'
            }
        }
    },

    watch: {
        totalResults: function(val) {
            this.loadPageSelectOptions()
        }//,
        // currentPageNumber: function() {
        //     this.currentPageNumber = this.currentPageNumber // this avoids binding dropdowns to a property, which causes errors when they change
        // }
    },

    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        threadingSearchJSON: function() {
            return this.$store.state.threadingSearchJSON
        },
        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },
        draftImageUrlFunction: function() {
            return this.$store.state.draftImageUrlFunction
        },
        currentOrientation: function() {
            if (this.isAuthenticated()) {
                return this.$store.state.authUserSettings.Orientation
            }
            return 'tl'
        },
        totalPages: function() {
            if (this.totalResults === 0) {
                return 0 // 0 results means 0 pages
            }
            let totalPagesCount = Math.floor((this.totalResults-1) / this.itemsPerPage) + 1 // 1 to 50 results means 1 pages, etc...
            let partialPageItemsCount = this.totalResults - (totalPagesCount * this.itemsPerPage)

            if (partialPageItemsCount > 0) {
                totalPagesCount++
            }
            return totalPagesCount
        }
    },
    created() {
        this.currentPageNumber = this.initialPageNumber
    },
    updated() {
        this.currentPageNumber = this.initialPageNumber
    }
}
</script>

<style scoped>
.captions {
    font-size: 0.7rem;
    display: table-caption;
    width: 100%;
    margin-left: 0.5rem;
    background-color: #f9f8f5;
    padding: 0.25rem;
    white-space: nowrap
}

.captionsShowing {
    margin: 0.7rem;
}

.captionsHidden {
    margin: 0;
}

.big-left-margin {
    margin-left: 1.0rem;
}

figure {
    padding: 5px;
    display: table;
}

figure img {
    display: block;
}

figcaption {
    display: table-caption;
    caption-side: top;
}
</style>
